import { render } from "./RecipeCardPlaceholder.vue?vue&type=template&id=9f80380e&scoped=true"
import script from "./RecipeCardPlaceholder.vue?vue&type=script&lang=js"
export * from "./RecipeCardPlaceholder.vue?vue&type=script&lang=js"

import "./recipeCard.css?vue&type=style&index=0&id=9f80380e&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f80380e"]])

export default __exports__